import axios from 'axios'
import Router from '../router'
import Vue from "vue";

axios.create({
    withCredentials: true, // 是否携带cookie
    timeout: 5000 // 请求超时
})
axios.interceptors.request.use(
    config => {
        // 如果有token，则增加token字段到请求中
        if(Vue.prototype.GetQueryString("token")){
            config.data.token = Vue.prototype.GetQueryString("token")
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)


axios.interceptors.response.use(
    response => {
        // 检测某种状态进行重定向
        if (response.data.code === 403) {
            Router.push({
                name: 'login'
            })
        }
        return response
    },
    error => {
        return Promise.resolve(error.response)
    }
)


export default axios